// src/stores/themeStore.ts
import { create } from "zustand";
import Cookies from "js-cookie";
import { InvalidateQueryFilters } from "@tanstack/react-query";
import { userKeys } from "@/api/user";
import { queryClient } from "@/api/query-client";

interface UserStore {
  token?: string;
}
interface UserStoreActions {
  clearToken: () => void;
}

const useUserStore = create<UserStore & UserStoreActions>((set) => {
  const token = Cookies.get("token");
  return {
    token: token,
    clearToken: () => {
      set({ token: undefined });
      queryClient.invalidateQueries(userKeys.logged as InvalidateQueryFilters);
    },
  };
});

export default useUserStore;
